'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('ifeis.alert', ['ngMaterial']).factory('fAlert', function ($mdDialog) {
  return function (event, title, message) {
    var fAlert = $mdDialog.alert().title(title).textContent(message).targetEvent(event).ok('Close');

    return $mdDialog.show(fAlert);
  };
});


//////////////////
// WEBPACK FOOTER
// ./alert/index.js
// module id = 205
// module chunks = 0